import { render, staticRenderFns } from "./profile-sceleton.vue?vue&type=template&id=09462696&scoped=true&"
import script from "./profile-sceleton.vue?vue&type=script&lang=js&"
export * from "./profile-sceleton.vue?vue&type=script&lang=js&"
import style0 from "./profile-sceleton.vue?vue&type=style&index=0&id=09462696&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09462696",
  null
  
)

export default component.exports